import { createContext } from 'react';

import { DndContextInterface, DefaultInterface } from '../../models/dnd-context-interface';

const DndContext = createContext<DndContextInterface>(DefaultInterface);

export { DndContext };
